import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import { useAuthStore } from './stores/useAuthStore'
import LoginPage from './pages/LoginPage'
import InvitePage from './pages/InvitePage'
import TodayPage from './pages/TodayPage'
import CalendarPage from './pages/CalendarPage'
import ReportsPage from './pages/ReportsPage'
import ImportPage from './pages/ImportPage'
import BillingsPage from './pages/admin/BillingsPage'
import ClientsPage from './pages/admin/ClientsPage'
import SettingsPage from './pages/admin/SettingsPage'
import ProjectsPage from './pages/admin/ProjectsPage'
import UsersPage from './pages/admin/UsersPage'

function Protected({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, loaded } = useAuthStore()
  const location = useLocation()
  if (!loaded) return <div className="p-10 text-center text-slate-400">Načítání…</div>
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />
  if (adminOnly && !user.isAdmin) return <Navigate to="/today" replace />
  return <Layout>{children}</Layout>
}

export default function App() {
  const { load, loaded } = useAuthStore()

  useEffect(() => {
    load()
  }, [load])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/today" element={<Protected><TodayPage /></Protected>} />
      <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
      <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
      <Route path="/import" element={<Protected><ImportPage /></Protected>} />
      <Route path="/admin/billings" element={<Protected adminOnly><BillingsPage /></Protected>} />
      <Route path="/admin/settings" element={<Protected adminOnly><SettingsPage /></Protected>} />
      <Route path="/admin/clients" element={<Protected adminOnly><ClientsPage /></Protected>} />
      <Route path="/admin/projects" element={<Protected adminOnly><ProjectsPage /></Protected>} />
      <Route path="/admin/users" element={<Protected adminOnly><UsersPage /></Protected>} />
      <Route path="*" element={<Navigate to={loaded ? '/today' : '/login'} replace />} />
    </Routes>
  )
}
